// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-container {
  display: flex;
  flex-direction: row;
  padding: 0 20px 20px 20px;
  background-color: #f6f9f9;
}
.schedule-container .time-column {
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 26.5px;
}
.schedule-container .time-column .time-slot {
  padding: 0 5px 5px 5px;
  height: 25px;
  margin-bottom: 28px;
  color: #909dad;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.schedule-container .time-column .time-slot:last-child {
  opacity: 0;
}
.schedule-container .clinic-columns {
  margin-top: 10px;
  display: flex;
  flex: 1 1;
  margin-left: 6px;
}
.schedule-container .clinic-columns .clinic-column {
  flex: 1 1;
  position: relative;
}

.appointment-slot {
  height: 30px;
  border: 1px solid #dce0e5;
  cursor: pointer;
  transition: all 0.3s linear;
  background-color: #ffffff;
}

.full-hour {
  font-weight: bold;
}

.full-hour-line {
  height: 53px;
}

.half-hour {
  font-size: 12px;
  font-style: italic;
}

.appointment-slot:hover {
  background-color: #b6d0e8;
  border: 1px solid #0f5291;
  border-radius: 6px;
}

.half-hour-line {
  border-top: 1px dashed #ddd;
  height: 53px;
}

.appointment {
  background-color: #f8f6e7;
  z-index: 2;
  width: calc(100% + 2px);
  position: absolute;
  transform: translateY(-53px);
  left: -1px;
  padding: 6px 6px 6px 12px;
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  border-radius: 12px;
  gap: 6px;
  overflow-y: hidden;
  cursor: pointer;
  box-sizing: border-box;
  border: 2px solid transparent;
  transition: border-color 0.3s ease-in-out;
}

.closed_appointment {
  background-color: #e8f9e8;
}

.appointment:hover {
  border-color: #115da3;
}

.hasDontVisited {
  background-color: #ebeef2;
}

.appointment::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0;
  width: 6px;
  height: 100%;
  background-color: #0f5291;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.hasDontVisitedappointment::before {
  background-color: #909dad;
}

.appointment_timer {
  padding: 4px 6px;
  background-color: #0f5291;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  border-radius: 8px;
}

.hasDontVisited_timer {
  background-color: #909dad;
}

.appointment_patient_name {
  color: #090b0e;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.appointment_doc_name {
  color: #546881;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.full-hour-line {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.half-hour-line {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
}

.after-19-line {
  border-bottom: 2px solid red;
}`, "",{"version":3,"sources":["webpack://./src/components/ScheduleComponents/ScheduleTable/ScheduleTable.scss","webpack://./styles/_colors.scss","webpack://./styles/_typography.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBCE+B;ADJnC;AAGI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AADR;AAEQ;EACI,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,cCiCG;ECqCX,gBAAA;EACA,eAAA;EACA,iBAAA;AFrEJ;AAAQ;EACI,UAAA;AAEZ;AACI;EACI,gBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;AACR;AAAQ;EACI,SAAA;EACA,kBAAA;AAEZ;;AAGA;EACI,YAAA;EACA,yBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBCEU;ADFd;;AAEA;EACI,iBAAA;AACJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,eAAA;EACA,kBAAA;AAEJ;;AACA;EACI,yBC/CuB;EDgDvB,yBAAA;EACA,kBAAA;AAEJ;;AACA;EACI,2BAAA;EACA,YAAA;AAEJ;;AACA;EACI,yBCrDY;EDsDZ,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,yCAAA;AAEJ;;AAAA;EACI,yBClE0B;ADqE9B;;AADA;EACI,qBC7EwB;ADiF5B;;AADA;EACI,yBCnDS;ADuDb;;AADA;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,yBChGqB;EDiGrB,2BAAA;EACA,8BAAA;AAIJ;;AADA;EACI,yBC/DW;ADmEf;;AADA;EACI,gBAAA;EACA,yBC3GqB;ED4GrB,cC5EU;EC4CV,gBAAA;EACA,eAAA;EACA,iBAAA;EFgCA,kBAAA;AAMJ;;AAHA;EACI,yBC3EW;ADiFf;;AAHA;EACI,cCnGgB;ECyDhB,gBAAA;EACA,eAAA;EACA,iBAAA;EF0CA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAQJ;;AALA;EACI,cC3H6B;ECwE7B,gBAAA;EACA,eAAA;EACA,iBAAA;EFmDA,gBAAA;AAUJ;;AARA;EACI,4BAAA;EACA,2BAAA;AAWJ;;AARA;EACI,+BAAA;EACA,8BAAA;AAWJ;;AARA;EACI,4BAAA;AAWJ","sourcesContent":["@import \"../../../../styles/colors\";\r\n@import \"../../../../styles/_typography.scss\";\r\n\r\n.schedule-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    padding: 0 20px 20px 20px;\r\n    background-color: $header-menu-background-container;\r\n    .time-column {\r\n        width: 50px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        margin-top: 26.5px;\r\n        .time-slot {\r\n            padding: 0 5px 5px 5px;\r\n            height: 25px;\r\n            margin-bottom: 28px;\r\n            color: $icons_grey_2;\r\n            @include typography($body3);\r\n        }\r\n        .time-slot:last-child {\r\n            opacity: 0;\r\n        }\r\n    }\r\n    .clinic-columns {\r\n        margin-top: 10px;\r\n        display: flex;\r\n        flex: 1;\r\n        margin-left: 6px;\r\n        .clinic-column {\r\n            flex: 1;\r\n            position: relative;\r\n        }\r\n    }\r\n}\r\n\r\n.appointment-slot {\r\n    height: 30px;\r\n    border: 1px solid $divider;\r\n    cursor: pointer;\r\n    transition: all 0.3s linear;\r\n    background-color: $color-white;\r\n}\r\n.full-hour {\r\n    font-weight: bold;\r\n}\r\n.full-hour-line {\r\n    height: 53px;\r\n}\r\n\r\n.half-hour {\r\n    font-size: 12px;\r\n    font-style: italic;\r\n}\r\n\r\n.appointment-slot:hover {\r\n    background-color: $header-menu-border-color;\r\n    border: 1px solid $header-menu-text-color;\r\n    border-radius: 6px;\r\n}\r\n\r\n.half-hour-line {\r\n    border-top: 1px dashed $shedule-item-line-color;\r\n    height: 53px;\r\n}\r\n\r\n.appointment {\r\n    background-color: $event-surface;\r\n    z-index: 2;\r\n    width: calc(100% + 2px);\r\n    position: absolute;\r\n    transform: translateY(-53px);\r\n    left: -1px;\r\n    padding: 6px 6px 6px 12px;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    border-radius: 6px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: start;\r\n    border-radius: 12px;\r\n    gap: 6px;\r\n    overflow-y: hidden;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n    border: 2px solid transparent;\r\n    transition: border-color 0.3s ease-in-out;\r\n}\r\n.closed_appointment {\r\n    background-color: $closed-appointment-bg-color;\r\n}\r\n.appointment:hover {\r\n    border-color: $shedule-item-border-color;\r\n}\r\n\r\n.hasDontVisited {\r\n    background-color: $skeleton_2;\r\n}\r\n\r\n.appointment::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 0;\r\n    width: 6px;\r\n    height: 100%;\r\n    background-color: $header-menu-text-color;\r\n    border-top-left-radius: 6px;\r\n    border-bottom-left-radius: 6px;\r\n}\r\n\r\n.hasDontVisitedappointment::before {\r\n    background-color: $icons_grey_2;\r\n}\r\n\r\n.appointment_timer {\r\n    padding: 4px 6px;\r\n    background-color: $header-menu-text-color;\r\n    color: $color-white;\r\n    @include typography($caption1);\r\n    border-radius: 8px;\r\n}\r\n\r\n.hasDontVisited_timer {\r\n    background-color: $icons_grey_2;\r\n}\r\n\r\n.appointment_patient_name {\r\n    color: $black-dark-active;\r\n    @include typography($caption1);\r\n    font-weight: 500;\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n    text-align: left;\r\n}\r\n\r\n.appointment_doc_name {\r\n    color: $shedule-text-color-item-doctor;\r\n    @include typography($link1);\r\n    text-align: left;\r\n}\r\n.full-hour-line {\r\n    border-top-right-radius: 6px;\r\n    border-top-left-radius: 6px;\r\n}\r\n\r\n.half-hour-line {\r\n    border-bottom-right-radius: 6px;\r\n    border-bottom-left-radius: 6px;\r\n}\r\n\r\n.after-19-line {\r\n    border-bottom: 2px solid red;\r\n}\r\n","// NAVIGATION\r\n$nav-background-container: #07243f;\r\n$nav-background-container-hover: #0b3e6d;\r\n$nav-background-selected-item: #092e51;\r\n$nav-background-users-cabinet: #109439;\r\n\r\n// GENERAL\r\n\r\n// HEADER MENU\r\n$header-menu-background-container: #f6f9f9;\r\n$header-menu-border-color: #b6d0e8;\r\n// $header-menu-border-color: #e7f0f8;\r\n$header-menu-text-color: #0f5291;\r\n\r\n// SHEDULE TABLE\r\n$event-surface: #f8f6e7;\r\n$shedule-text-color-item-doctor: #546881;\r\n$shedule-item-border-color: #115da3;\r\n$shedule-item-line-color: #ddd;\r\n$shedule-item-title-color: #808080;\r\n$shedule-item-subtitle-color: #151414;\r\n$shedule-drawer-bottum-dorder-color: #dfdede;\r\n\r\n// DRAWER COMPONENT\r\n$drawer-container-bg-color: #bfbfca;\r\n$closed-appointment-bg-color: #e8f9e8;\r\n\r\n// DRAWER COMPONENT\r\n// $drawer-container-bg-color: #bfbfca;\r\n\r\n// BLACK\r\n$black-dark-active: #090b0e;\r\n$black-normal-hover: #47586e;\r\n\r\n// SURFACES\r\n$surfaces-light-hover: #f5f7f9;\r\n$surfaces-light-white-bg-input: #bcc3cd;\r\n$surfaces-normal-hover-white: #f2f4f7;\r\n\r\n// ERROR\r\n$error-normal-active: #ad1313;\r\n$text-error_caption: #ec8d8d;\r\n\r\n// GENERAL//\r\n$color-white: #ffffff;\r\n$divider: #dce0e5;\r\n\r\n$skeleton_2: #ebeef2;\r\n\r\n// ICONS  //\r\n\r\n$icons_grey_2: #909dad;\r\n$icons_success: #119e13;\r\n$icons_warning: #ca6602;\r\n\r\n// BUTTONS  //\r\n$buttons_stroke_outlined_destructive: #f5c6c6;\r\n$buttons_stroke_solid: #1367b5;\r\n$buttons_fill_all_disabled: #d0d6dc;\r\n$buttons_close_chevron_delete_edit_btn_enabled: #546881;\r\n\r\n$buttons_primary_enabled_destructive: #c21616;\r\n\r\n$buttons_primary_pressed_destructive: #a21212;\r\n\r\n$buttons_outlined_enabled: #161919;\r\n$buttons_outlined_hovered: #e7f0f8;\r\n$buttons_outlined_pressed: #dce8f4;\r\n$buttons_outlined_enabled_destructive: #fdf2f2;\r\n$buttons_outlined_hovered_destructive: #fbe9e9;\r\n$buttons_outlined_pressed_destructive: #f9dcdc;\r\n\r\n// LINKS  //\r\n\r\n$link_hovered: #151a20;\r\n$color-white-gray: #e3e3e8;\r\n$color-complete-appointment: #cfcfcf;\r\n","@import \"./colors\";\r\n\r\n$heading1: (\r\n    font-weight: 600,\r\n    font-size: 32px,\r\n    line-height: 40px,\r\n);\r\n\r\n$heading2: (\r\n    font-weight: 500,\r\n    font-size: 24px,\r\n    line-height: 36px,\r\n);\r\n\r\n$heading3: (\r\n    font-weight: 400,\r\n    font-size: 20px,\r\n    line-height: 28px,\r\n);\r\n\r\n$heading4: (\r\n    font-weight: 500,\r\n    font-size: 32px,\r\n    line-height: 40px,\r\n    color: $black-dark-active,\r\n);\r\n\r\n$body1: (\r\n    font-weight: 600,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body2: (\r\n    font-weight: 500,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body3: (\r\n    font-weight: 400,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body-small1: (\r\n    font-weight: 600,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$body-small2: (\r\n    font-weight: 500,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$body-small3: (\r\n    font-weight: 400,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$caption1: (\r\n    font-weight: 500,\r\n    font-size: 12px,\r\n    line-height: 14px,\r\n);\r\n\r\n$caption2: (\r\n    font-weight: 600,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$link1: (\r\n    font-weight: 400,\r\n    font-size: 12px,\r\n    line-height: 14px,\r\n);\r\n\r\n$headline3: (\r\n    font-weight: 500,\r\n    font-size: 20px,\r\n    line-height: 28px,\r\n);\r\n\r\n@mixin typography($style) {\r\n    font-weight: map-get($style, font-weight);\r\n    font-size: map-get($style, font-size);\r\n    line-height: map-get($style, line-height);\r\n    @if map-has-key($style, color) {\r\n        color: map-get($style, color);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
